import { cn } from 'cn';
import type { ComponentPropsWithRef, ReactElement } from 'react';

export type BaseInputProps = {
  error?: boolean;
  valid?: boolean;
  after?: React.ReactNode;
} & ComponentPropsWithRef<'input'>;

export function BaseInput({
  className,
  error,
  valid,
  after,
  ref,
  ...props
}: BaseInputProps): ReactElement {
  const hasAfter = after !== undefined && after !== null && after !== '';

  return (
    <div className="relative flex items-center justify-center">
      <input
        {...props}
        ref={ref}
        data-testid={props.name}
        aria-invalid={!valid}
        className={cn(
          'w-full',
          {
            'pr-10': hasAfter,
            'border-red-100! ring-red-100!': error,
          },
          className,
        )}
      />
      {hasAfter ? (
        <span className="typ-ui absolute right-2.5 top-[0.54rem] text-neutral-100">
          {after}
        </span>
      ) : null}
    </div>
  );
}
